
import React, { useEffect, useState } from 'react'
import { Constants } from '../../../CommonMethhods/Constants';
import { AESEncryption, ApiResDecrypt, checkDateRange, compareDate } from '../../../CommonMethhods/CommonMethods';
import axios from 'axios';
import { CLIENT_FNO, Client_Search, Dashboard_Client_Report } from '../../../Configuration/API_URL';
import $ from "jquery";

import LoaderForSearch from '../../../Components/Common/LoaderForSearch';
import { toast } from 'react-toastify';
import moment from 'moment';
import Select from "react-select";
import ClientFnoLossTable from '../../ClientFnoLoss/ClientFnoLossTable';
import PartnerCommTable from './PartnerCommTable';
import { partner_Api } from '../../../Configuration/Partner_URL';

export default function PartnerCommissionModule(props) {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [clientList, setClientList] = useState([]);
    const [scroll, setScroll] = useState(false);
    const [clientName, setClientName] = useState("");
    const [clientCode, setClientCode] = useState("");
    const [serverError, setServerError] = useState("");
    const [scrollLoader, setScrollLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [errorResp, setErrorResp] = useState("");
    const [errorRespYe, setErrorRespYe] = useState("");
    const [errorRespMo, setErrorRespMo] = useState("");

    const [nameError, setNameError] = useState("");
    const [gridVal, setGridVal] = useState("");
    const [loader, setLoader] = useState(false);
    const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
    const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
    const [clientNameError, setClientNameError] = useState(false);
    const [pageTable, setPageTable] = useState(1)
    const [count, setCount] = useState()
    const [scrollLoaderTable, setScrollLoaderTable] = useState(false)
    const storeToken = localStorage.getItem("ssoToken");
    const currentYear = new Date().getFullYear();
    const [commission, setCommission] = useState("");


    // Create array of last 10 years


    const [selectedYear, setSelectedYear] = useState(null);
    const options = [
        { value: "ProfessionalPack", label: "Professional Pack" },
        { value: "FreedomPack", label: "Freedom Pack" },

    ];

    const [selectedMonth, setSelectedMonth] = useState(null);
    console.log(selectedMonth, "selectedMonth");
    const [yearDataList, setYearDataList] = useState([])
    useEffect(() => {
        getYears()

    }, [])

    useEffect(()=>{
       if(props.checkTab!=="comission"){
        setErrorRespMo("")
        setErrorRespYe("")
        setSelectedMonth(null)
        setCommission("")
       }
    },[props.checkTab])

    async function getYears() {
        try {
            const response = await axios.get(
                partner_Api.Getpacks,
                // "https://uat-cosmos.bajajfinservsecurities.in/api/rm/partner/getpacks",
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 0,
                    },
                }
            );

            const res = response?.data;
            console.log(res, "API Response");

            if (res?.status === 0 && Array.isArray(res?.data)) {
                const formattedData = res.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                setYearDataList(formattedData);
            } else {
                console.log("No data found");
            }
        } catch (err) {
            console.error("Error fetching pack list:", err);
        }
    }
    console.log(yearDataList, "yearDataList");

    const optionsYear = yearDataList.map((year) => ({
        value: year,
        label: year.toString(),
    }));

    async function searchApiDetail(e) {
        $(".write-search.clientfno").addClass("show-result scroll-table");
        let payloadValue = {
            keyword: e.toUpperCase(),
            Status: "",
            PageNo: page,
            PageSize: 10,
        };
        let encPayload = AESEncryption(payloadValue);
        try {
            const getSearchDetail = await axios.post(
                Client_Search.Search_URL,

                `"${encPayload}"`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 1,
                    },
                }
            );

            const res = ApiResDecrypt(getSearchDetail?.data);

            if (res.message === "Client does not exist.") {
                setClientList([
                    { clientname: "Client does not exist.", clientCode: null },
                ]);
            } else {
                if (scroll == true) {
                    setClientList((prev) => {
                        return [...prev, ...res.data.clients];
                    });
                    setServerError("");
                } else {
                    setClientList(res.data.clients);
                    setServerError("");
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setScrollLoader(false);
        }
    }
    function clientSet(name, code, i) {
        if (name === "Client does not exist.") {
            setClientCode("")
            $(".write-search.clientfno").addClass("show-result scroll-table");
        } else {
            $(".write-search.clientfno").removeClass("show-result");
            setClientList([]);
            setClientName(name);
            setClientCode(code);
            setScrollLoader(false);
        }
    }

    const handleClientName = (e) => {
        setScrollLoader(false);
        // setFileType("");
        console.log("handle client name", e.target.value)
        if (e.target.value) {
            setClientList([]);
            setScroll(false);
            let result = e.target.value.toUpperCase();
            setClientName(result);
            if (e.target.value.length > 3) {
                setPage(1);
                setClientList([]);
                setScroll(false);
                searchApiDetail(e.target.value);
            }
        } else {
            // setFileType("");
            setClientCode("")
            setClientList([]);
            setPage(1);
            setClientName("");
            setScroll(false);
            $(".write-search.clientfno").removeClass("show-result");
        }
        $(".write-search.clientfno-li").click(function () {
            $(".write-search.clientfno").addClass("show-result scroll-table");
        });
    };
    const handleScroll = async () => {
        setScroll(true);
        const a = document.querySelector("#clientfno-scroll");
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
            setPage((prev) => prev + 1);
            setScrollLoader(true);
            searchApiDetail(clientName);
        }
    };

    // const getDetailsPayload = async (fileType, rmCode, pageSize = 5, offset) => {
    //     if (fileType === "grid" && offset > 1) {
    //         setLoader(false)
    //         setSmallLoaderExcel(false);
    //         setSmallLoaderPdf(false);
    //     }
    //     else if (fileType == "excel") {
    //         setSmallLoaderExcel(true);
    //         setSmallLoaderPdf(false);
    //         setLoader(false);
    //     } else if (fileType == "pdf") {
    //         setSmallLoaderExcel(false);
    //         setSmallLoaderPdf(true);
    //         setLoader(false);
    //     } else {
    //         setSmallLoaderExcel(false);
    //         setSmallLoaderPdf(false);
    //         setLoader(true)
    //     }
    //     let payloadValue = {
    //         clientCode: clientCode,
    //         month: selectedMonth?.value ? selectedMonth?.value : "",
    //         year: selectedYear?.value ? selectedYear?.value : 0,
    //         searchBy: rmCode,
    //         fileType: fileType,
    //         pageSize: pageSize,
    //         pageNo: offset,
    //     };
    //     console.log("payloadValue", payloadValue)
    //     let encPayload = AESEncryption(payloadValue);
    //     try {
    //         const getDetails = await axios.post(
    //             CLIENT_FNO.Get_Client_FnO,
    //             `"${encPayload}"`,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${storeToken}`,
    //                     reserv: 1,
    //                 },
    //             }
    //         );
    //         const res = ApiResDecrypt(getDetails?.data);
    //         console.log("res client fno", res)
    //         if (res?.data) {
    //             if (fileType == "grid") {
    //                 setCount(res?.data?.totalCount)
    //                 if (offset > 1) {
    //                     setGridVal((prev) => {
    //                         return [...prev, ...res?.data?.fnoLossDetails];
    //                     })
    //                 } else {
    //                     setGridVal(res?.data?.fnoLossDetails);

    //                 }
    //                 // setGridVal(res?.data);
    //             } else if (fileType == "excel") {
    //                 window.open(res?.data, "_self", "noopener,noreferrer");
    //             } else if (fileType == "pdf") {
    //                 window.open(res?.data, "_blank", "noopener,noreferrer");
    //             }

    //         } else {
    //             setGridVal([]);
    //             if (fileType == "excel") {
    //                 toast.error("Client F&O Report does not exist.");
    //             } else if (fileType == "pdf") {
    //                 toast.error("Client F&O Report does not exist.");
    //             }
    //         }
    //         setClientNameError(false);
    //         setLoader(false);
    //         setSmallLoaderExcel(false);
    //         setSmallLoaderPdf(false);
    //         setScrollLoaderTable(false)
    //     } catch (error) {
    //         console.log(error);
    //         setLoader(false);
    //         setSmallLoaderExcel(false);
    //         setSmallLoaderPdf(false);

    //         setServerError("Something went wrong, Please try again later.");
    //         if (fileType == "excel") {
    //             toast.error("Something went wrong, Please try again later.");
    //         }
    //         if (fileType == "pdf") {
    //             toast.error("Something went wrong, Please try again later.");
    //         }

    //     }
    // };

    useEffect(() => {
        getCommisionDataList("grid", "", -1, -1)
    }, [])

    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");

    const handleDownloadBtn = () => {
        getCommisionDataList("grid", "", 10, 1);
    }
    const handleFromDateChange = (e) => {
        if (e.target.value) {
            // setFileType("");
            setGridVal("");
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setFromDate(d);
            setErrorResp("");
            setServerError("");
        }
        else {
            setFromDate("")
            setErrorResp("");
            setServerError("");
        }
    };
    const handleToDateChange = (e) => {
        if (e.target.value) {
            setGridVal("");
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setToDate(d);
            setErrorResp("");
            setServerError("");
        }
        else {
            setToDate("")
            setErrorResp("");
            setServerError("");
        }

    };
    function formatDate(date) {
        return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
    }

    // const handleOnClick = (e) => {
    //     setPageTable(1)
    //     console.log("Clicked", selectedMonth.value, commission);

    // };
    // const handleOnClick = async(e) => {
    //     e.preventDefault();
    //     setPageTable(1);
    //     let hasError = false;
    //     setErrorRespMo("");
    //     setErrorRespYe("");
    //     if (!selectedMonth) {
    //         setErrorRespMo("Pack Type is required");
    //         hasError = true;
    //     }
    //     if (!commission || commission.trim() === "") {
    //         setErrorRespYe("Account Opening Commission is required");
    //         hasError = true;
    //     }
    //     if (hasError) return;
    //     console.log("Clicked", selectedMonth.value, commission);
    //     const payload = {
    //         packType: selectedMonth.label, // e.g., "Professional"
    //         commission: Number(commission), // ensure numeric
    //     };

    //     try {
    //         // Optional: show loader here
    //         setLoader(true);

    //         const response = await axios.post(
    //             "https://uat-cosmos.bajajfinservsecurities.in/api/rm/partner/insertcommission",
    //             payload,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${storeToken}`,
    //                     reserv: 0,
    //                 },
    //             }
    //         );

    //         const res = response?.data;
    //         console.log("Insert Commission Response:", res);

    //         if (res?.status === 0) {
    //             // ✅ success case
    //             toast.success("Commission inserted successfully!");
    //             setCommission("");
    //             setSelectedMonth(null);
    //             getYears(); // refresh data if needed
    //         } else {
    //             // ❌ API responded with error status
    //             toast.error(res?.message || "Failed to insert commission");
    //         }

    //     } catch (err) {
    //         console.error("Error inserting commission:", err);
    //         toast.error("Something went wrong, please try again later.");
    //     } finally {
    //         setLoader(false);
    //     }
    // };
    const handleOnClickCancle = () => {
        setSelectedMonth("")
        setCommission("")
        setErrorRespMo("")
        setErrorRespYe("")
    }
    const handleOnClick = async (e) => {
        e.preventDefault();
        setPageTable(1);

        let hasError = false;
        setErrorRespMo("");
        setErrorRespYe("");

        // Validate pack type
        if (!selectedMonth) {
            setErrorRespMo("Pack Type is required");
            hasError = true;
        }
        // if (!selectedMonth) {
        //     setErrorRespMo("Pack Type is required");
        //     hasError = true;
        // }

        // Validate commission
        if (!commission || commission.trim() === "") {
            setErrorRespYe("Account Opening Commission is required");
            hasError = true;
        } else {
            const floatValue = parseFloat(commission);

            if (isNaN(floatValue)) {
                setErrorRespYe("Please enter a valid number");
                hasError = true;
            } else if (floatValue === 0) {
                setErrorRespYe("Value cannot be 0");
                hasError = true;
            } else if (floatValue < 10 || floatValue > 10000) {
                setErrorRespYe("Value must be between 10 and 10,000");
                hasError = true;
            }
        }

        if (hasError) return;

        // Prepare payload
        const insertPayload = {
            packType: selectedMonth.label,
            commission: Number(commission),
        };

        try {
            setLoader(true);
            const insertRes = await axios.post(
                partner_Api.Insertcommission,
                insertPayload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 0,
                    },
                }
            );

            console.log("Insert Commission Response:", insertRes.data);

            if (insertRes?.data?.status === 0) {
                toast.success(insertRes?.data.data);
                getCommisionDataList("grid", "", -1, -1);
            } else {
                toast.error(insertRes?.data?.message || "Failed to insert commission");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("Something went wrong, please try again later.");
        } finally {
            setLoader(false);
        }
    };

    // const handleOnClick = async (e) => {
    //     e.preventDefault();
    //     setPageTable(1);

    //     let hasError = false;
    //     setErrorRespMo("");
    //     setErrorRespYe("");
    //     if (!selectedMonth) {
    //         setErrorRespMo("Pack Type is required");
    //         hasError = true;
    //     }

    //     if (!commission || commission.trim() === "") {
    //         setErrorRespYe("Account Opening Commission is required");
    //         hasError = true;
    //     }

    //     if (hasError) return;

    //     const insertPayload = {
    //         packType: selectedMonth.label,
    //         commission: Number(commission),
    //     };

    //     try {
    //         setLoader(true);
    //         const insertRes = await axios.post(
    //             partner_Api.Insertcommission,
    //             // "https://uat-cosmos.bajajfinservsecurities.in/api/rm/partner/insertcommission",
    //             insertPayload,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${storeToken}`,
    //                     reserv: 0,
    //                 },
    //             }
    //         );

    //         console.log("Insert Commission Response:", insertRes.data);

    //         if (insertRes?.data?.status === 0) {
    //             toast.success(insertRes?.data.data);
    //             // getCommisionDataList()
    //             getCommisionDataList("grid", "", -1, -1);
    //         } else {
    //             toast.error(insertRes?.data?.message || "Failed to insert commission");
    //         }
    //     } catch (error) {
    //         console.error("Error:", error);
    //         toast.error("Something went wrong, please try again later.");
    //     } finally {
    //         setLoader(false);
    //     }
    // };

    const getCommisionDataList = async (fileType = "grid", search = "", pageSize = 10, offset = 1) => {
        const getDetailsPayload = {
            search,
            offset,
            limit: pageSize,
            fileType,
        };
        // console.log(getDetailsPayload, "getDetailsPayload");
        // const encPayload = AESEncryption(getDetailsPayload)

        try {
            const getDetailsRes = await axios.post(
                partner_Api.Getcommissiondetails,
                // "https://uat-cosmos.bajajfinservsecurities.in/api/rm/partner/getcommissiondetails",
                getDetailsPayload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 0,
                    },
                }
            );
            // const res = ApiResDecrypt(getDetailsRes?.data)

            if (getDetailsRes?.data?.status === 0) {
                // debugger
                if (fileType === "grid") {
                    const newData = getDetailsRes?.data?.data?.commissions || [];
                    console.log(newData, "gridData");

                    if (offset > 1) {
                        setGridVal((prev) => [...prev, ...newData]);
                    } else {
                        setGridVal(newData);
                    }
                } else if (fileType === "excel") {
                    // Handle Excel download
                    const excelUrl = getDetailsRes?.data?.data; // or whatever key contains the file
                    if (excelUrl) {
                        window.open(excelUrl, "_self", "noopener,noreferrer");
                        // toast.success("Excel downloaded successfully!");
                    }
                }
            } else {
                toast.error(getDetailsRes?.data?.message);
            }
        } catch (error) {
            console.error("Error fetching commission data:", error);
            toast.error("Something went wrong while fetching data");
        }

        setCommission("");
        setSelectedMonth(null);
    };

    console.log(gridVal, "gridVals");

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: "none",
            border: "1px solid #ccc",
            "&:hover": {
                border: "1px solid #ccc",
            },
        }),
    };
    const customStylesYears = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: "none",
            border: "1px solid #ccc",
            "&:hover": {
                border: "1px solid #aaa",
            },
        }),
    };

    const handleCommissionChange = (e) => {
        const value = e.target.value;
        const decimalRegex = /^\d{0,5}(\.\d{0,2})?$/;
        if (value === "" || decimalRegex.test(value)) {
            setCommission(value);
            const floatValue = parseFloat(value);
            if (value !== "" && (floatValue < 10 || floatValue > 10000)) {
                setErrorRespYe("Value must be between 10 and 10,000");
            } else {
                setErrorRespYe("");
            }
        }
    };

    return (
        <div className='social-media partner-payout'>

            <div className="card-box">
                <div className="row input-field-wrapper-partner">


                    <div class="form-group" style={{ width: "290px" }}>
                        <label className="form-label">Pack Type<span style={{ color: "red" }}>*</span></label>
                        <Select
                            options={yearDataList} // ✅ dynamic API data
                            value={selectedMonth}
                            onChange={(value) => {
                                setSelectedMonth(value);
                                setErrorRespMo("");
                                setSelectedYear([]);
                            }}
                            placeholder="Select Pack..."
                            isSearchable
                            styles={customStyles}
                        />
                        {errorRespMo && (
                            <span className="to-date-error month-error" style={{ color: "red" }}>{errorRespMo}</span>
                        )}
                    </div>
                    <div class="form-group" style={{ width: "290px" }}>
                        <label className="form-label">Account Opening Commission<span style={{ color: "red" }}>*</span></label>
                        <div className='input-text-wrapper align-items-center'>
                            <input
                                type="text"
                                className="input-st"
                                placeholder="Enter amount"
                                value={commission}
                                onChange={handleCommissionChange}
                            />
                        </div>

                        {errorRespYe && (
                            <span className="to-date-error month-error" style={{ color: "red" }} >{errorRespYe}</span>
                        )}
                    </div>
                </div>
                <div className="text-center search-btn-wrapper-partner">
                    <button
                        value="grid"
                        className="send-message cancel-b"
                        onClick={() => handleOnClickCancle()}
                    >
                        Cancel
                    </button>
                    <button
                        value="grid"
                        className="send-message"
                        onClick={handleOnClick}
                    >
                        Submit
                    </button>
                </div>
                <PartnerCommTable
                    gridVal={gridVal}
                    smallLoaderExcel={smallLoaderExcel}
                    loader={loader}
                    setLoader={setLoader}
                    setScrollLoaderTable={setScrollLoaderTable}
                    scrollLoaderTable={scrollLoaderTable}
                    count={count}
                    // getClientFno={getCommisionDataList}
                    getCommisionDataList={getCommisionDataList}
                    handleDownloadBtn={handleDownloadBtn}
                    setPageTable={setPageTable}
                    checkTab={props.checkTab}
                    pageTable={pageTable} />               
            </div>

        </div>
    )
}
